import type { Viewport } from '../../engine/hex/camera2d';
import type { MapModel } from '../../engine/map/mapModel';
import type { HexMapState } from '../../engine/render/renderer';
import { ActionBar } from './components/ActionBar';
import { DismissibleStack } from './components/DismissibleStack';
import { InfoPanel } from './components/InfoPanel';
import { InstructionsBar } from './components/InstructionsBar';
import type { IconRegistry } from './assets/IconRegistry';
import type { Painter } from './rendering/Painter';
import { buildOverlayVM } from './vm/buildOverlayVM';
import type { HitTarget } from './components/ActionBar';

export class OverlayRenderer {
    private actionBar: ActionBar;
    private infoPanel = new InfoPanel();
    private instructions = new InstructionsBar();
    private dismissibleStack = new DismissibleStack();

    constructor(
        private painter: Painter,
        private icons: IconRegistry,
    ) {
        this.actionBar = new ActionBar({ icons });
    }

    render(args: {
        model: MapModel;
        state: HexMapState;
        viewport: Viewport;
        zoom: number;
    }): HitTarget[] {
        const vm = buildOverlayVM({
            model: args.model,
            state: args.state,
            viewport: args.viewport,
            zoom: args.zoom,
            icons: this.icons,
            measureText: this.painter.measureText.bind(this.painter),
        });

        const targets: HitTarget[] = [];
        targets.push(...this.actionBar.render(this.painter, vm.actionBar));
        vm.actionMenus.forEach((menu) => {
            targets.push(...this.actionBar.render(this.painter, menu));
        });
        if (vm.infoPanel.lines.length > 0) {
            this.infoPanel.render(this.painter, vm.infoPanel);
        }
        this.instructions.render(this.painter, vm.instructions);

        if (vm.notifications) {
            targets.push(...this.dismissibleStack.render(this.painter, vm.notifications));
        }

        if (vm.alerts) {
            targets.push(...this.dismissibleStack.render(this.painter, vm.alerts));
        }

        return targets;
    }
}
